var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vector",
    _vm._b({ style: { fill: _vm.color } }, "vector", _vm.$props, false),
    [
      _vm.layers
        ? _c(
            "g",
            [
              _c("layer", {
                attrs: {
                  position: _vm.layers["octopus"],
                  layer: _vm.layers["octopus"]
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }